import React from 'react';
import { HeartIcon, HandshakeIcon, DollarSignIcon } from 'lucide-react';
export const SupportCTA = () => {
  return <section id="support" className="py-16 bg-blue-50" data-id="element-1851">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1852">
        <div className="text-center mb-12" data-id="element-1853">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-4" data-id="element-1854">
            Support Our Mission
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-1855">
            Help us continue our independent research and education on
            microbiome science
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1856">
          <div className="bg-white rounded-xl overflow-hidden shadow-md p-8 text-center" data-id="element-1857">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 text-blue-600 mb-6" data-id="element-1858">
              <DollarSignIcon size={28} data-id="element-1859" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1860">
              Make a Donation
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-1861">
              Your financial contribution helps fund independent research and
              educational initiatives.
            </p>
            <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-md transition-colors duration-200" data-id="element-1862">
              Donate Now
            </button>
          </div>
          <div className="bg-white rounded-xl overflow-hidden shadow-md p-8 text-center" data-id="element-1863">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 text-blue-600 mb-6" data-id="element-1864">
              <HandshakeIcon size={28} data-id="element-1865" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1866">
              Partner With Us
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-1867">
              Collaborate on research projects, sponsor educational content, or
              engage in joint initiatives.
            </p>
            <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-md transition-colors duration-200" data-id="element-1868">
              Explore Partnerships
            </button>
          </div>
          <div className="bg-white rounded-xl overflow-hidden shadow-md p-8 text-center" data-id="element-1869">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 text-blue-600 mb-6" data-id="element-1870">
              <HeartIcon size={28} data-id="element-1871" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1872">Volunteer</h3>
            <p className="text-gray-600 mb-6" data-id="element-1873">
              Contribute your skills and time to help advance our mission and
              community outreach.
            </p>
            <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-md transition-colors duration-200" data-id="element-1874">
              Get Involved
            </button>
          </div>
        </div>
        <div className="mt-12 bg-white p-8 rounded-xl shadow-md" data-id="element-1875">
          <div className="text-center mb-6" data-id="element-1876">
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-1877">Our Impact</h3>
            <p className="text-gray-600" data-id="element-1878">
              See how your support makes a difference
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1879">
            <div className="text-center" data-id="element-1880">
              <div className="text-3xl font-bold text-blue-600 mb-2" data-id="element-1881">25+</div>
              <p className="text-gray-700" data-id="element-1882">Research Studies Published</p>
            </div>
            <div className="text-center" data-id="element-1883">
              <div className="text-3xl font-bold text-blue-600 mb-2" data-id="element-1884">
                10,000+
              </div>
              <p className="text-gray-700" data-id="element-1885">People Educated</p>
            </div>
            <div className="text-center" data-id="element-1886">
              <div className="text-3xl font-bold text-blue-600 mb-2" data-id="element-1887">100+</div>
              <p className="text-gray-700" data-id="element-1888">Products Tested</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};